let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gLLAC")).then(() => parcelRequire('hlIyV'));